import { Link } from "react-router-dom";

export interface ArticleSummary {
  id: string;
  title: string;
  category: string;
  categorySlug: string;
  excerpt: string;
  cover: string;
  heat: number;
  publishedAt: string;
  tags: string[];
  author: string;
  source: string;
}

interface ArticleCardProps {
  article: ArticleSummary;
  variant?: "vertical" | "horizontal";
  showExcerpt?: boolean;
}

export default function ArticleCard({
  article,
  variant = "vertical",
  showExcerpt = true,
}: ArticleCardProps) {
  if (variant === "horizontal") {
    return (
      <article className="group flex gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300 md:gap-5 md:p-4">
        <Link
          to={`/article/${article.id}`}
          className="relative h-20 w-28 shrink-0 overflow-hidden rounded-md bg-background-200 md:h-24 md:w-40"
        >
          <img
            src={article.cover}
            alt={`${article.title} - ${article.category}热点事件配图`}
            title={`${article.title} 52吃瓜网`}
            className="h-full w-full object-cover object-top"
          />
        </Link>
        <div className="flex min-w-0 flex-1 flex-col">
          <div className="flex items-center gap-2">
            <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-xs font-label text-secondary-900">
              {article.category}
            </span>
            <span className="flex items-center gap-1 text-xs font-label text-primary-600">
              <i className="ri-fire-line"></i>
              {article.heat}万
            </span>
          </div>
          <Link to={`/article/${article.id}`}>
            <h3 className="mt-2 line-clamp-2 font-heading text-base font-bold text-foreground-950 transition-colors group-hover:text-primary-700">
              {article.title}
            </h3>
          </Link>
          {showExcerpt ? (
            <p className="mt-1.5 line-clamp-2 text-sm leading-relaxed text-foreground-600 font-label">
              {article.excerpt}
            </p>
          ) : null}
          <span className="mt-auto pt-2 text-xs font-label text-foreground-400">
            {article.publishedAt}
          </span>
        </div>
      </article>
    );
  }

  return (
    <article className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300">
      <Link
        to={`/article/${article.id}`}
        className="relative block h-44 w-full overflow-hidden bg-background-200"
      >
        <img
          src={article.cover}
          alt={`${article.title} - ${article.category}热点事件配图`}
          title={`${article.title} 52吃瓜网`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 rounded-full bg-background-50/90 px-2.5 py-1 text-xs font-label font-medium text-primary-700 backdrop-blur">
          {article.category}
        </span>
      </Link>
      <div className="flex flex-1 flex-col p-4 md:p-5">
        <Link to={`/article/${article.id}`}>
          <h3 className="line-clamp-2 font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-lg">
            {article.title}
          </h3>
        </Link>
        {showExcerpt ? (
          <p className="mt-2.5 line-clamp-3 text-sm leading-relaxed text-foreground-600 font-label">
            {article.excerpt}
          </p>
        ) : null}
        <div className="mt-auto flex flex-wrap items-center gap-x-4 gap-y-2 pt-4 text-xs font-label text-foreground-400">
          <span className="flex items-center gap-1 text-primary-600">
            <i className="ri-fire-line"></i>
            热度 {article.heat}万
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-time-line"></i>
            {article.publishedAt}
          </span>
        </div>
      </div>
    </article>
  );
}